module.exports = __webpack_public_path__ + "86d6c8ebe47131f647ae287265b379dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/tesla_2023_chart.png
// module id = 1748
// module chunks = 0